<template>
  <!-- USAGE example (see video conf form): <AvailableExtensions :extension="parseInt(username)" @setModel="setUsername"/> -->
  <div>
    <v-menu
      ref="menu"
      v-model="extensionMenu"
      :close-on-content-click="false"
      :return-value.sync="extensionToUse"
      transition="scale-transition"
      offset-x
      min-width="auto"
      data-testid="available-extensions-menu"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field v-model="extensionToUse" prepend-icon="mdi-numeric" type="number" data-testid="available-extensions-textfield"
          :label="$t('availableExtensions.extension')" class="mt-4" v-bind="attrs" v-on="on"></v-text-field>
      </template>
      <v-card min-width="300">
        <v-card-title>{{ $t('availableExtensions.title') }}</v-card-title>
        <v-divider></v-divider>
        <v-text-field v-model="extensionToSearch" prepend-icon="mdi-magnify" type="number" data-testid="available-extensions-search-textfield"
          :label="$t('availableExtensions.usernameToSearch')" class="mx-2 mt-4"></v-text-field>
        <v-card height="300" style="overflow-y: scroll" elevation="0">
          <v-list dense class="justify-center">
            <v-list-item-group
              v-model="selectedExtension"
              color="primary">
              <v-list-item
                v-for="(item, index) in availableExtensions"
                data-testid="available-extensions-list-item"
                :key="index">
                <v-list-item-title>{{ item }}</v-list-item-title>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'available-extensions',
  data () {
    return {
      extensionToUse: this.extension,
      extensionMenu: null,
      selectedExtension: null,
      extensionToSearch: this.extension || 1000
    }
  },
  created () {
    this.getAvailableExtensions(this.extensionToSearch)
  },
  watch: {
    extensionToSearch () {
      this.selectedExtension = null
      this.getAvailableExtensions(this.extensionToSearch)
    },
    selectedExtension () {
      if (this.selectedExtension !== null) {
        this.$refs.menu.save(this.availableExtensions[this.selectedExtension])
      }
    },
    extensionToUse () {
      this.$emit('setModel', this.extensionToUse)
    }
  },
  props: {
    extension: {
      type: Number,
      default: 1000
    }
  },
  computed: {
    ...mapGetters({
      availableExtensions: 'availableExtensions/list'
    })
  },
  methods: {
    ...mapActions({
      getAvailableExtensions: 'availableExtensions/load'
    })
  }
}
</script>

<style>

</style>
